import { useTranslation } from "react-i18next";
import PageTitle from "../../components/common/PageTitle/PageTitle";
import { CircularIndeterminate } from "../../components/common/CircularIndeterminate";
import { useProcessingRequest } from "../../store/selectors/tableManagementSelector";
import { useEffect } from "react";
import PermissionSettings from "./PermissionSettings";
import { useAppDispatch } from "../../hooks/StoreHooks";
import { fetchAllPermissionsThunk } from "../../store/thunk/permissionsThunk";
import { fetchGroupsThunk } from "../../store/thunk/groupsThunk";
import { fetchServiceModulesThunk } from "../../store/thunk/serviceModulesThunk";
import { fetchActionModules } from "../../store/thunk/actionsModulesThunk";
import { fetchSubCompaniesThunk } from "../../store/thunk/subCompaniesThunk";

const breadcrumbs = [];

const PermissionsPage = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const processingRequest = useProcessingRequest()

    useEffect(() => {
        dispatch(fetchAllPermissionsThunk());
        dispatch(fetchGroupsThunk());
        dispatch(fetchServiceModulesThunk());
        dispatch(fetchActionModules());
        dispatch(fetchSubCompaniesThunk());
    }, []);

    return (
        <>
            <PageTitle
                breadcrumbs={breadcrumbs}
                title={t("permissionsPage.title")}
            />
            <PermissionSettings />
            <CircularIndeterminate processingRequest={processingRequest} />
        </>
    )
}

export default PermissionsPage